import React, { useState, useEffect } from "react";
import { ArborescenceBâtimentaireV2 } from "../actif_arborescence/ArborescenceBâtimentaire";
import { sitesSerivces, unitesOrganisationSerivces } from "../../services";
import { CustomDialog, showToast } from "..";
import { Actif, Site, UniteOrganisation } from "../../interfaces";
import { useQueryClient } from "@tanstack/react-query";

interface ModalCorrespondanceUniteProps {
  modalIsOpenCorrespondance: boolean;
  closeModalCorrespondance: () => void;
  actif: Actif;
  unite: UniteOrganisation;
  unités: UniteOrganisation[];
  setUnités: any;
  setLoading: (newvalue: boolean) => void;
}
const ModalCorrespondanceUnite = ({
  modalIsOpenCorrespondance,
  closeModalCorrespondance,
  actif,
  unite,
  unités,
  setUnités,
  setLoading,
}: ModalCorrespondanceUniteProps) => {
  const queryClient = useQueryClient();
  const [site, setSite] = useState<Site>(null);
  const [selectedBâtiments, setSelectedBâtiments] = useState([]);
  const [selectedNiveaux, setSelectedNiveaux] = useState([]);
  const [selectedEspaces, setSelectedEspaces] = useState([]);
  const [selectedPieces, setSelectedPieces] = useState([]);

  const onSubmit = async () => {
    try {
      const data_correspondance = {
        unite_id: unite.id,
        actif_id: actif.id,
        batiment_ids: selectedBâtiments,
        niveau_ids: selectedNiveaux,
        espace_ids: selectedEspaces,
        piece_ids: selectedPieces,
      };
      setLoading(true);
      const response = await unitesOrganisationSerivces.correspondanceunite(
        data_correspondance
      );
      setLoading(false);
      showToast("success", "Correspondance unité effectué avec succès");
      setUnités([...unités, response.data]);
      setSelectedBâtiments([]);
      setSelectedNiveaux([]);
      setSelectedEspaces([]);
      setSelectedPieces([]);
      queryClient.refetchQueries({
        queryKey: ["actif"],
      });
      closeModalCorrespondance();
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  useEffect(() => {
    const fetchSiteApi = async (id) => {
      try {
        setLoading(true);
        const response = await sitesSerivces.getById(id);
        setSite(response);
        setLoading(false);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    fetchSiteApi(actif?.site_id);
  }, [actif]);

  return (
    <>
      <CustomDialog
        header="Correspondance des unités"
        visible={modalIsOpenCorrespondance}
        closeModalDialog={() => {}}
      >
        <div className="w-full h-full ">
          <div className="p-6 space-y-6">
            <h3 className="text-gray-900 font-bold mb-4">
              Arborescence bâtimentaire
            </h3>

            <div className="border rounded-lg">
              <div className="relative w-full max-h-96 overflow-auto space-y-4 mx-10 my-2">
                <ArborescenceBâtimentaireV2
                  site={site}
                  actif={actif}
                  checkbox={true}
                  batimentIds={actif?.bâtiments.map((batiment) => batiment.id)}
                  niveauIds={actif?.niveaux.map((niveau) => niveau.id)}
                  espaceIds={actif?.espaces.map((espace) => espace.id)}
                  pieceIds={actif?.pieces.map((piece) => piece.id)}
                  setSelectedBâtiments={setSelectedBâtiments}
                  setSelectedNiveaux={setSelectedNiveaux}
                  setSelectedEspaces={setSelectedEspaces}
                  setSelectedPieces={setSelectedPieces}
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-5">
              <button
                type="submit"
                className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
                onClick={onSubmit}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </CustomDialog>
    </>
  );
};

export default ModalCorrespondanceUnite;
